module.exports = __webpack_public_path__ + "static/media/branding-color.e0f416fe.svg";